let configApp = {
  routesNoAuth: [],
  default_foreign_key: {
    application_id: "81cb0181-348b-4990-8fc4-8bcfd0f3c763",
    application_instance_id: "013aee58-14f6-4f74-ada7-e95e8eadfcf9",
    application_profile_id: "873a904f-00a7-4d0b-a015-af668203e26a",
    profiles: {
      admin: "873a904f-00a7-4d0b-a015-af668203e26a",
      generalAdmin: "8dac7fe9-a67b-42fd-ae66-81d770eb4540",
      zellusAdmin: "db00bb72-14ab-4190-bb75-3addbb3380b2",
    },
    sdg_profiles: {
      admin: "873a904f-00a7-4d0b-a015-af668203e26a",
      clientManager: "203ee187-e73b-4bc4-a81f-f188586b502e",
      cityManager: "a87bcce8-f52e-4c85-bbda-46af7400470b",
      secretariatManager: "95956851-c3e6-46ee-8a7b-9f10d0e91f92",
      departmentManager: "5d0f5c2a-5bdb-42d6-b82c-aa4feb01e913",
    },
  },
  screen_configs: {
    fileForm: {
      fileTypesToShowYears: [
        "e394cc15-429a-4dd0-afee-e8ff0be1de5a",
        "cf931832-aa3c-4b86-8aae-622dfe41a7d9",
        "a5dbde03-fc35-4b82-b24d-69ee1b248da2",
        "9b50e6e7-af6b-489b-b37d-bbe9a673796f",
        "354703cc-b18c-4a9a-b407-19bffac8c53b",
        "1af8010b-53e8-42bf-9b57-2a3d8d7489af",
        "16a0c086-9fe9-4b87-959b-6cabe96e59ee",
        "b8ecd102-f40f-44f9-96f3-c40ff5d5f846",
        "50dfea81-258d-4b47-b306-92a981f46b9c",
        "61ba1d1c-bcc8-406c-9622-6d943166c9c8",
        "932a63ba-02aa-438e-abb4-b17637db7d15",
        "0bbcfede-1db3-4e6c-a5fe-e583deb14725",
        "e0a321ad-e23f-4b6b-b993-66a8beb97747",
        "3f39d2b0-8ea9-4081-8c83-7630c6c67f5b",
        "9992f738-0140-4d9a-8a92-8d46a26e050d",
        "451800e0-190a-4e21-b148-2c828bb1c72f",
        "a0499a6b-044a-45bb-97c4-a71e83ea9822",
        "6728f92c-e8e2-4b12-b03d-44dbb8ba12f9",
        "be009017-fb90-448a-8112-f03ec9a93ab2",
        "39e1f681-7c45-4fd5-a5e8-bb7e2ad8a71d",
        "9d0c91f0-8fa6-434e-bf6a-d06880c6d381",
        "98df89e3-bc56-4d87-936a-45f4dab9996b",
        "3bcda323-c236-4fcd-8cb7-19afdd4742db",
        "d38731f6-2f75-445f-bd74-70bc538f5aeb",
        "14ad4a89-d3fd-4c44-8c39-f66bd2fcd760",
        "126c4875-b115-4329-ac71-9caeacdfb8a1",
        "53bcb6b6-2422-468a-b306-e727e41f048a",
        "9eda15f6-762b-43db-b9fd-1d8f7bda3687",
        "3622f6b9-ae43-46f6-8cf4-1712331acd46",
        "b5e6a3c2-d4f1-4a9e-8b7c-0f2e3d4a5b6c",
        "f3a2b1c0-d4e5-4f6a-b7c8-d9e0f1a2b3c4",
        "f9340b82-333a-4047-a645-14ab58b9fd57",
        "133899d7-cfee-4801-980b-6f30df96d650",
        "06a8031d-d1ad-4919-84d7-7e841d8af915",
        "f0c844a9-4473-4e48-8854-13d28a629d80",
        "5284a7bf-c6de-47bb-90fa-b9c245700fa5",
      ],
      fileTypesToShowCities: [
        "6401e8cc-bbc8-42d6-b8d0-2119394b3cfc",
        "66f10b50-44a6-47c7-a1dc-e4c65b607083",
        "99e8ebe7-1a55-4561-9d61-40e96232ecd5",
        "0bbcfede-1db3-4e6c-a5fe-e583deb14725",
        "e0a321ad-e23f-4b6b-b993-66a8beb97747",
        "d9af7a84-0135-473f-92f4-af87273b93ea",
      ],
      fileTypesToShowMonths: [
        "3622f6b9-ae43-46f6-8cf4-1712331acd46",
        "5284a7bf-c6de-47bb-90fa-b9c245700fa5",
      ],
      fileTypesToShowPeriods: ["d9af7a84-0135-473f-92f4-af87273b93ea"],
      citiesToShowMonths: ["3522307"],
      periods: {
        yearly: "90a95d0e-dcd8-45ce-9f4e-366bbed6055b",
        monthly: "caceeb22-cf75-4bb2-9a4a-b09ea3523e28",
      },
    },
  },
};
export default configApp;
